// DiscoverFlixMoreRow.js
import DiscoverFlixProvider from '../container/DiscoverFlixProvider.js';
import DiscoverFlixMoreRow from '../component/DiscoverFlixMoreRow.jsx';

export default DiscoverFlixProvider(DiscoverFlixMoreRow);
